import Vue from 'vue'
import App from './App.vue'

//使用element-ui
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';

//使用富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

//引入cookies
import Cookies from 'js-cookie'
Vue.prototype.$cookie = Cookies;
//引入全局scss
import '@/assets/styles/index.css';
//引入方法
//时间过滤
import filter from '@/utils/filter/data'
Vue.prototype.$formatTimestamp = filter.formatTimestamp;
//引入store
import store from './store/index.js';
//引入router
import VueRouter from 'vue-router'
import router from './router/index.js';
// import '@/assets/js/flexible.js';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI);
Vue.use(VueQuillEditor)

//全局注册组件
import Component from '@/utils/index.js'
Vue.use(Component)
//引入API
import API from '@/request/api.js';
Vue.prototype.$api = API;
//全局变量域名
// 本地运行
// let httpurl = 'https://zf3.tongfenghui.com'
// 服务器运行
let httpurl = 'https://houtai5698.koiodeal.com'
Vue.prototype.imgurl = httpurl;
Vue.prototype.uploadimg = httpurl + "/api/index/uploadimg"
Vue.prototype.uploadfile = httpurl + "/api/index/uploadimg"

//全局过滤器 秒
Vue.filter('formatTimestamp', filter.formatTimestamp)

new Vue({
  router,
  store: store,  //或者直接写store
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this; //创建全局事件总线
  }
}).$mount('#app')
